import { Component } from '@angular/core';
import { Http } from '@angular/http';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';

import { GRANTUPDATEVIEWLABELS } from '../../../_constants/constants';
import { Scope } from '../../../_models/data.structures';
import { ConsentService } from './../../../_services/consent.service';
import { IMyDpOptions, IMyInputFieldChanged } from 'mydatepicker';

import { NotificationDialogComponent } from './../../../notification/notification.dialog.component';

import { TranslatePipe } from '../../../shared/translate/translate.pipe';

export interface GrantUpdateModel {
    title: string;
    scopes: Scope[];
    nonScopes: string[];
    subValue: string;
    opcoValue: string;
    appId: string;
    consentService: ConsentService;
}

@Component({
    templateUrl: './grant-update.dialog.component.html',
    providers: [TranslatePipe]
})

export class GrantUpdateDialogComponent extends DialogComponent<GrantUpdateModel, string> implements GrantUpdateModel {

    title: string;
    scopes: Scope[];
    nonScopes: string[];
    subValue: string;
    opcoValue: string;
    appId: string;
    grantupdateviewlabels = GRANTUPDATEVIEWLABELS;
    expirationTime: string;
    consentService: ConsentService;


    monthsTranslated: any = [];

    appExpireDay: any = "";
    appExpireMonth: any = "0";
    appExpireYear: any = "";
    expiryDateError: boolean = false;
    expiryDateErrMsg = "";

    objectKeys = Object.keys;
    
    constructor(private ds: DialogService, private http: Http, private translatePipe: TranslatePipe) {
        super(ds);

        this.monthsTranslated = this.translatePipe.transform("CALENDAR_MONTHS", 'CALENDAR_SELECT_VALUES');

        this.expiryDateError = false;
        this.expiryDateErrMsg = "";
    }

    private myDatePickerOptionsgrantexp: IMyDpOptions = {
          dateFormat: 'yyyy-mm-dd',
          height: '34px',
          width: '100%',
          inline: false,
          editableDateField: false,
          disableUntil: {year: (new Date()).getFullYear(), month: (new Date()).getMonth()+1, day: (new Date()).getDate()-1}
      };

    // Add or remove clicked checkbox/scope to nonscope for body generation
    checkBoxClicked(scopeId: string) {
        if(this.nonScopes !== null){
            const index = this.nonScopes.indexOf(scopeId);
            if (index > -1) {
                this.nonScopes.splice(index, 1);
            } else {
                this.nonScopes.push(scopeId);
            }
        }
    }

    checkIfNonScope(scopeId: string): boolean {
        if(this.nonScopes !== null){
            return this.nonScopes.indexOf(scopeId) > -1;
        }
    }

    // ASSUMING: scopes and nonscopes have no element in common
    getPayload(): string {
        let returnValue = '{';
        if (this.expirationTime) {
            const currentDateTime = new Date().getTime() / 1000;
            const selectedDateTime = new Date(this.expirationTime).getTime() / 1000;
            const expirationSeconds = Math.floor(selectedDateTime - currentDateTime);
            returnValue += '\"expirationTime\":' + '\"' + expirationSeconds + '\",';
        }

        returnValue += '\"scopes\":[';
        if(this.scopes !== null){
            for (const scope of this.scopes) {
                if (!this.checkIfNonScope(scope.scopeId)) {
                    returnValue += '\"' + scope.scopeId + '\",';
                }
            }
        }
       
        if (!returnValue.endsWith('\":[')) {
            returnValue = returnValue.substring(0, returnValue.length - 1);
        }

        returnValue += '], \"nonGrantedScopes\":[';
        if(this.nonScopes !== null){
            for (const scopeId of this.nonScopes) {
                returnValue += '\"' + scopeId + '\",';
            }
        }

        if (!returnValue.endsWith('\":[')) {
            returnValue = returnValue.substring(0, returnValue.length - 1);
        }

        returnValue += ']}';
        console.log(returnValue);
        return returnValue;
    }




    onlyNumber(e) {
        e = (e) ? e : window.event;
        var charCode = (e.which) ? e.which : e.keyCode;

        if ([46, 8, 9, 27, 13, 110, 190].indexOf(e.keyCode) !== -1 ||
            // Allow: Ctrl+A
            (e.keyCode === 65 && (e.ctrlKey || e.metaKey)) ||
            // Allow: Ctrl+C
            (e.keyCode === 67 && (e.ctrlKey || e.metaKey)) ||
            // Allow: Ctrl+V
            (e.keyCode === 86 && (e.ctrlKey || e.metaKey)) ||
            // Allow: Ctrl+X
            (e.keyCode === 88 && (e.ctrlKey || e.metaKey)) ||
            // Allow: home, end, left, right
            (e.keyCode >= 35 && e.keyCode <= 39)) {
            // let it happen, don't do anything
            return;
        }
        // Ensure that it is a number and stop the keypress
        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
            e.preventDefault();
        }

        this.expiryDateError = false;
        this.expiryDateErrMsg = "";
    }

    isNumeric(str) {
        var pattern = /^\d+$/;
        return pattern.test(str);
    }


    onBlurDayExpiry(evt) {
        let val = evt.target.value;

        if (parseInt(val) >= 1 && parseInt(val) <= 9) {
            if (val.length == 1) {
                this.appExpireDay = "0" + this.appExpireDay;
            }
        }
    }

    sendUpdatedData() {

        let valid = true;


        if (this.appExpireYear != "" && this.appExpireDay != "") {

            if (this.appExpireMonth == "0") {

                valid = false;

                this.expiryDateError = true;
                this.expiryDateErrMsg = this.translatePipe.transform("INVALID_EXPIRY_DATE_ERROR", 'CLIENT_SIDE_VALIDATION_ERROR');                
                return;
            }
            else if (parseInt(this.appExpireYear) == 0 || parseInt(this.appExpireDay) == 0 || this.isNumeric(this.appExpireYear) === false || this.isNumeric(this.appExpireDay) === false) {

                valid = false;

                this.expiryDateError = true;
                this.expiryDateErrMsg = this.translatePipe.transform("INVALID_EXPIRY_DATE_ERROR", 'CLIENT_SIDE_VALIDATION_ERROR'); 
                return;
            }
            else {

                let expirationDate = new Date(this.appExpireYear + "/" + this.appExpireMonth + "/" + this.appExpireDay);
                let currentDate = new Date();

                if (expirationDate < currentDate) {

                    valid = false;

                    this.expiryDateError = true;
                    this.expiryDateErrMsg = this.translatePipe.transform("PAST_EXPIRATION_ERROR", 'CLIENT_SIDE_VALIDATION_ERROR');                     
                    return;
                }               
            }
        }
        else if (this.appExpireMonth != "0" && (this.appExpireYear == "" || this.appExpireDay == "")) {

            valid = false;

            this.expiryDateError = true;
            this.expiryDateErrMsg = this.translatePipe.transform("INVALID_EXPIRY_DATE_ERROR", 'CLIENT_SIDE_VALIDATION_ERROR');             
            return;
        }
        else if (this.appExpireDay != "" && (this.appExpireMonth == "0" || this.appExpireYear == "")) {

            valid = false;

            this.expiryDateError = true;
            this.expiryDateErrMsg = this.translatePipe.transform("INVALID_EXPIRY_DATE_ERROR", 'CLIENT_SIDE_VALIDATION_ERROR');             
            return;
        }
        else if (this.appExpireYear != "" && (this.appExpireMonth == "0" || this.appExpireDay == "")) {

            valid = false;

            this.expiryDateError = true;
            this.expiryDateErrMsg = this.translatePipe.transform("INVALID_EXPIRY_DATE_ERROR", 'CLIENT_SIDE_VALIDATION_ERROR'); 
            return;
        }
        else {
            this.expirationTime = "";
        }

        if (valid) {            

            if (this.appExpireYear != "" && this.appExpireDay != "" && this.appExpireMonth != "0") {

                if (parseInt(this.appExpireMonth) <= 9 && this.appExpireMonth.length == 1) {
                    this.appExpireMonth = "0" + this.appExpireMonth;
                }
                this.expirationTime = this.appExpireYear + "-" + this.appExpireMonth + "-" + this.appExpireDay;
            }

        }

        this.consentService.singleGrantUpdate(this.subValue, this.opcoValue, this.appId, this.getPayload(), this.ds);
        this.close();
    }

    onGrantExpInputFieldChanged(event: IMyInputFieldChanged) {
      this.expirationTime = event.value;
  }
}



// WEBPACK FOOTER //
// ./src/app/details/consents/grant-update/grant-update.dialog.component.ts